import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import { RewardType } from '~/shared';
import shadow from '../../assets/images/shop_player_items/shop_player_item_shadow.png';

const StyledContainer = styled.div`
	position: relative;
	height: 250px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	overflow: hidden;
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -210px;
	left: 50%;
	transform: translateX(-50%);
	width: 420px;
	height: 420px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	pointer-events: none;
`;

const StyledBottomShadow = styled.div`
	position: absolute;
	width: 100%;
	height: 150px;
	bottom: 1px;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	opacity: 0.5;
	border-radius: 0px 0px 4px 4px;
	pointer-events: none;
`;

const StyledImageContainer = styled.div<{
	$type: RewardType;
	$isClothes: boolean;
}>`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);

	img {
		user-select: none;
		pointer-events: none;
	}

	${(props) =>
		props.$type === RewardType.VEHICLE &&
		css`
			top: 30px;
		`}

	${(props) =>
		(props.$type === RewardType.ITEM || props.$isClothes) &&
		css`
			top: 10px;
		`}

${(props) =>
		props.$type === RewardType.LOOTBOX &&
		css`
			top: 0;
		`}
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	bottom: 20px;
	left: 20px;
	right: 20px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 16px;

	& > ${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 16px;
		height: 16px;
	}

	${Text} {
		font-weight: 500;
	}
`;

const StyledButtonGrid = styled.div<{ $canBeSold: boolean }>`
	display: grid;
	grid-template-columns: ${({ $canBeSold }) =>
		$canBeSold ? '1fr 1fr' : '1fr'};
	gap: 10px;
`;

const StyledCount = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 5px;
	position: absolute;
	top: 20px;
	left: 20px;
	height: 20px;
	background: #1782ff;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledExpContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-top: 60px;

	${Text} {
		font-weight: 700;
		font-size: 30px;
		color: #ffffff;
	}
`;

export {
	StyledBottomContainer,
	StyledBottomShadow,
	StyledButtonContent,
	StyledButtonGrid,
	StyledContainer,
	StyledCount,
	StyledExpContainer,
	StyledImageContainer,
	StyledShadow,
};
